import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { ModelSetTransformer } from '../common/common.model';
import { mapList } from '../common/rest.operators';

import { AreaItem, AreaItemModelSetTransformer } from './area.location.model';
import {
    RegionItem,
    RegionItemModelSetTransformer,
} from './region.location.model';
import { SiteItem, SiteItemModelSetTransformer } from './site.location.model';

@Injectable()
export class LocationService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    private _list<T, U>(
        which: string,
        transformer: new () => ModelSetTransformer<T, U>,
    ): Observable<T[]> {
        const params = new HttpParams().set('scopeID', '18');

        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.LOCATION}/location/${which}`,
                { params },
            )
            .pipe(
                // eslint-disable-next-line new-cap
                mapList(new transformer()),
                catchError((error) => {
                    console.error(error);
                    throw new Error(`${which} failed`);
                }),
            );
    }

    listRegions(): Observable<RegionItem[]> {
        return this._list('GetAvailableRegions', RegionItemModelSetTransformer);
    }

    listAreas(): Observable<AreaItem[]> {
        return this._list('GetAvailableAreas', AreaItemModelSetTransformer);
    }

    listSites(): Observable<SiteItem[]> {
        return this._list('GetAvailableSites', SiteItemModelSetTransformer);
    }
}
